/**
 * @hidden
 */
var _getInnerActiveElement = function getInnerActiveElement(element) {
  var shadowRoot = element.shadowRoot;
  var contentDocument = element.contentDocument;
  if (shadowRoot && shadowRoot.activeElement) {
    return _getInnerActiveElement(shadowRoot.activeElement);
  }
  if (contentDocument && contentDocument.activeElement) {
    return _getInnerActiveElement(contentDocument.activeElement);
  }
  return element;
};
/**
 * @hidden
 */
export { _getInnerActiveElement as getInnerActiveElement };
export var getActiveElement = function getActiveElement(document) {
  if (!document || !document.activeElement) {
    return undefined;
  }
  return _getInnerActiveElement(document.activeElement);
};